import { Divider } from '@mui/material';
import styled from 'styled-components';

export const StyledDivider = styled(Divider)<{ $isTablet: boolean }>`
  margin: ${({ theme: { spacing }, $isTablet }) => ($isTablet ? spacing(0) : spacing(2, 0))};
  background-color: ${({ theme: { color, palette } }) => palette.mode === 'dark' && color.borderGrayDark};
`;

export const StyledAnchor = styled.a`
  color: inherit;
  text-decoration: underline;
`;
